import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareBehindSquare1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSquareBehindSquare1"><Path fillRule="evenodd" clipRule="evenodd" d="M2 2H16V8H22V22H8V16H2V2ZM14.5 8H8V14.5H3.5V3.5H14.5V8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareBehindSquare1;
